export default function FeatureSection() {
  const features = [
    {
      icon: 'ri-4k-line',
      title: '超高清画质',
      description: '支持360P至4K超高清画质，智能适配您的网络环境，自动选择最佳清晰度，让每一帧画面都清晰细腻。',
    },
    {
      icon: 'ri-speed-up-line',
      title: '极速流畅播放',
      description: '采用先进的CDN加速和P2P传输技术，全国多节点覆盖，确保播放流畅不卡顿，带来极致观影体验。',
    },
    {
      icon: 'ri-smartphone-line',
      title: '全平台同步',
      description: '支持电脑、平板、手机全平台无缝切换，观看记录自动同步，随时随地接续观看，不错过任何精彩。',
    },
    {
      icon: 'ri-shield-check-line',
      title: '安全无广告',
      description: '纯净的视频观看环境，无弹窗广告、无恶意软件，保护您的隐私安全，让您安心享受视频内容。',
    },
    {
      icon: 'ri-stack-line',
      title: '海量视频资源',
      description: '涵盖纪录片、教育、科技、美食、健身、音乐等十余个频道，海量视频库每日更新，总有你想看的内容。',
    },
    {
      icon: 'ri-chat-smile-2-line',
      title: '社区互动体验',
      description: '评论、收藏、分享功能一应俱全，与志同道合的视频爱好者一起讨论交流，让观影不再孤单。',
    },
  ];

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            为什么选择玖玖视频
          </h2>
          <p className="text-foreground-500 mt-2 text-sm md:text-base max-w-lg mx-auto">
            我们致力于打造极致视频观看体验，六大核心优势让观影更精彩
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature, index) => (
            <div
              key={index}
              className="p-6 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all group cursor-default"
            >
              <div className="w-11 h-11 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mb-4 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                <i className={`${feature.icon} text-lg`}></i>
              </div>
              <h3 className="text-base font-heading font-semibold text-foreground-900 mb-2">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}